<template>
  <!-- <div v-if="withButtons && mediaQueries" class="whatsapp-contact" :class="{'whatsapp-hidden': !show}">
    <a :href="social.whatsapp">
      <img width="80" height="80" src="@/assets/images/whatsapp.png" alt="واتساپ">
    </a>
  </div> -->
  <div :class="{ 'phone_icon_product_detaile': $route.name == 'product.detail' }" class="phone_icon" v-if="!loading">

    <a :href="`${content.settings.social.whatsapp ? content.settings.social.whatsapp : ''
      }`">
      <p class="text_phone">
        مشاوره رایگان
      </p>
      <span class="svg_phone">

        <svg xmlns="http://www.w3.org/2000/svg" width="21.451" height="21.489" viewBox="0 0 21.451 21.489">
          <path id="Icon_feather-phone-call" data-name="Icon feather-phone-call"
            d="M15.476,5.305a4.757,4.757,0,0,1,3.758,3.758M15.476,1.5a8.562,8.562,0,0,1,7.563,7.554m-.951,7.592V19.5a1.9,1.9,0,0,1-2.074,1.9,18.827,18.827,0,0,1-8.21-2.921A18.551,18.551,0,0,1,6.1,12.773,18.827,18.827,0,0,1,3.176,4.525,1.9,1.9,0,0,1,5.069,2.451H7.923a1.9,1.9,0,0,1,1.9,1.636,12.215,12.215,0,0,0,.666,2.673,1.9,1.9,0,0,1-.428,2.007L8.855,9.976a15.221,15.221,0,0,0,5.708,5.708l1.208-1.208a1.9,1.9,0,0,1,2.007-.428,12.215,12.215,0,0,0,2.673.666A1.9,1.9,0,0,1,22.088,16.645Z"
            transform="translate(-2.417 -0.672)" fill="none" stroke="#eb7400" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="1.5" />
        </svg>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "WhatsappContact",
  inject: ['mediaQueries'],
  watch: {
    $route() {
      this.$nextTick(() => {
        this.init()
      })
    }
  },
  computed: {
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },

  data() {
    return {
      show: true,
      lastScrollPosition: 0,
      withButtons: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    init() {
      this.withButtons = Boolean(document.querySelector('.footer-buttons'));
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.show = currentScrollPosition > 100
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>

<style scoped>
.text_phone {
  background-color: var(--newTheme-color);
  padding: 4px 10px;
  border-radius: 8px;
  position: relative;
  color: #fff;
  margin: 0;
  font-size: 14px;
  bottom: 16px;
  z-index: 1;
}

.text_phone::before {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  background-color: var(--newTheme-color);
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  z-index: -1;
  bottom: -6px;
  border-radius: 3px;
}

.phone_icon {
  position: fixed;
  bottom: 30px;
  left: 1%;

  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.phone_icon a {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.phone_icon .svg_phone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--newTheme-color);

  position: relative;
}

.phone_icon svg {
  animation: animetePhone 2s linear infinite;
  transform: rotateY(0deg);
}

.phone_icon .svg_phone:after,
.phone_icon .svg_phone:before {
  position: absolute;
  left: 0;
  top: 0;
  content: "";
  border-radius: 50%;
  width: 100%;
  height: 100%;
  border: 1px solid var(--newTheme-color);
  animation-name: popupBtn;
  animation-duration: 1.8s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.phone_icon .svg_phone:before {
  animation-delay: 0.8s;
}

@keyframes popupBtn {
  0% {
    transform: scale(1);
    opacity: 0;
  }

  50% {
    transform: scale(1.6);
    opacity: 0.3;
  }

  100% {
    transform: scale(2.2);
    opacity: 0;
  }
}

.phone_icon svg path {
  fill: #fff;
  stroke: #fff;
}

@keyframes animetePhone {
  0% {
    transform: rotateY(0deg) scale(1);
  }

  20% {
    transform: rotateY(0deg) scale(1.15);
  }

  30% {
    transform: rotateY(0deg) scale(1.15) rotate(25deg);
  }

  40% {
    transform: rotateY(0deg) scale(1.15) rotate(0);
  }

  50% {
    transform: rotateY(0deg) scale(1.15) rotate(-15deg);
  }

  60% {
    transform: rotateY(0deg) scale(1.15) rotate(0);
  }

  70% {
    transform: rotateY(0deg) scale(1.15) rotate(25deg);
  }

  80% {
    transform: rotateY(0deg) scale(1.15) rotate(0);
  }

  100% {
    transform: rotateY(0deg) scale(1) rotate(0);
  }
}



@media screen and (max-width:768px) {
  .phone_icon svg {
    width: 16px;
    height: 16px;
  }

  .phone_icon {
    bottom: 70px;
    left: 10px;

  }

  .phone_icon .svg_phone {
    width: 45px;
    height: 45px;
  }

  .text_phone {
    background-color: var(--newTheme-color);
    padding: 4px 8px;
    border-radius: 6px;
    bottom: 10px;

    font-weight: 700;
    font-size: 10px;
  }

  .phone_icon.phone_icon_product_detaile {
    bottom: 80px;
  }

  .text_phone::before {
    content: "";
    width: 16px;
    height: 16px;
    bottom: -3px;
    border-radius: 3px;
  }
}

/*.whatsapp-contact {
  position: fixed;
  bottom: 65px;
  right: 10px;
  z-index: 9;
}


.whatsapp-hidden {
  transform: translate3d(0, 100%, 0);
}

@media screen and (min-width: 768px) {
  .whatsapp-contact {
    bottom: 10px;
  }

  .whatsapp-hidden {
    transform: translate3d(0, 105%, 0);
  }
}*/
</style>
